import "core-js/modules/es.number.constructor.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visivel ? _c('div', {
    staticClass: "relatorio-empresas-selector mb-4"
  }, [_vm._m(0), _c('b-dropdown', {
    attrs: {
      "right": "",
      "variant": "light-primary",
      "menu-class": "relatorio-empresas-menu"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-building mr-2"
        }), _vm._v(_vm._s(_vm.resumoSelecao) + " ")];
      },
      proxy: true
    }], null, false, 1315788350)
  }, [_c('div', {
    staticClass: "px-3 py-2"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('strong', [_vm._v("Selecionar empresas")]), _c('button', {
    staticClass: "btn btn-link btn-sm p-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.selecionarTodas
    }
  }, [_vm._v(" Todas ")])]), _vm._l(_vm.empresasDoGrupo, function (empresa) {
    return _c('b-form-checkbox', {
      key: empresa.id_empresa,
      staticClass: "mb-2",
      attrs: {
        "value": Number(empresa.id_empresa)
      },
      on: {
        "change": _vm.atualizarContexto
      },
      model: {
        value: _vm.selecionadas,
        callback: function callback($$v) {
          _vm.selecionadas = $$v;
        },
        expression: "selecionadas"
      }
    }, [_vm._v(" " + _vm._s(_vm.nomeEmpresa(empresa)) + " "), Number(empresa.id_empresa) === _vm.empresaAtualId ? _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" (atual) ")]) : _vm._e()]);
  })], 2)])], 1) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    staticClass: "relatorio-empresas-kicker"
  }, [_vm._v("Relatório Multiempresa")]), _c('strong', {
    staticClass: "d-block"
  }, [_vm._v("Empresas incluídas no PDF")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Aplicado aos relatórios PDF compatíveis, com uma seção por empresa. ")])]);
}];
export { render, staticRenderFns };